<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ClaimApi from "@/services/claim-api";
import InvoicesApi from "@/services/invoices-api";
import CustomersApi from "@/services/customers-api";
import UsersApi from "@/services/users-api";
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}

export default {

  props:{
    supplierId: Number,
    blNumber:{
          type:String,
          default:""
      },
  },

  page: {
    title: "Reclamations & Suggestions",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mounted(){

      if(this.isAdmin && !this.isAgencySupplier){
        this.agencySelected = this.agencyList.length > 0 ? this.agencyList[0] : null;
      }

      if( this.canAccessClaimList){
        this.getClaims();
      }
      if(this.blNumber == "undefined" || this.blNumber ==null ){
        this.chosenBl = { number: null };
      }else{
        this.chosenBl = { number: this.blNumber };
      }
      if(this.canAccessCustomerList){
        this.getCustomers();
      }
      if(this.isClaimTypeEnabled){
        this.getClaimsServices();
        this.getALLClaimsServices();
      }
  },
  computed: {
        isPredifindSubjectClaimEnabled(){
          return  process.env.VUE_APP_FEATURE_PREDIFIND_SUBJECT_CLAIM === 'true'
        },
        isClaimReportingEnabled(){
          return  process.env.VUE_APP_FEATURE_CLAIM_REPORTING === 'true'
        },
        isClaimTypeEnabled(){
          return  process.env.VUE_APP_FEATURE_CLAIM_TYPE === 'true'
        },
        isExportClaimsCsvEnabled(){
          return  process.env.VUE_APP_FEATURE_EXPORT_CLAIMS_CSV === 'true'
        },
        role() {
          return this.$cookies.get('userr') ? this.$cookies.get('userr') : 0;
        },
        permission() {
          const  storedPermissions = JSON.parse(getCookie('permission')) || [];
          return storedPermissions
        },
        canAccessClaimList() {
          return (this.role === 0 || (this.permission && this.permission.some(pr => pr.includes('SUPPLIER_CLAIM_LIST') || pr.includes('SUPPLIER_CLAIM_SERVICE_MANAGER') || pr.includes('SUPPLIER_ADMIN'))));
        },
        isPartner() {
          const  isPartner = JSON.parse(getCookie('isPartner')) || false;
          return isPartner
        },

        canAccessCustomerList() {
          return (this.role === 1 && (this.isPartner || (this.permission && this.permission.some(pr => pr.includes('SUPPLIER_ADD_CLAIM') || pr.includes('SUPPLIER_ADD_ORDER')|| pr.includes('SUPPLIER_DOCUMENT_ACCESS') || pr.includes('SUPPLIER_ADMIN')))));
        },
        isAdmin() {
          return (this.role === 1 && (this.permission && this.permission.some(pr =>  pr.includes('SUPPLIER_ADMIN'))));
        },
        selectedServiceOptions() {
          const selected = this.editServicesList.find(s => this.selectedService?.value === s.id);
          return selected?.types?.map(type => ({ name: type.name, value: type.id })) ?? [];
        },

        tradersListOptions(){
          return this.tradersList.map(t => ({ name: t.name, value: t.id }))
        },
          
        isParaOnly(){
          return  process.env.VUE_APP_FEATURE_PARA_ONLY === 'true'
        },

        agencyList() {
          try {
            return JSON.parse(process.env.VUE_APP_FEATURE_AGENCY_LIST || "[]");
          } catch (e) {
            return [];
          }
        },

        filterByAgency() {
          return this.agencyList && this.agencyList.length > 1;
        },
        isAgencySupplier() {
          return this.$cookies.get('iss');
        },

    },

  components: { Layout },
  data() {
    return {

        agencySelected: null,
        claimsListFields: [
        
          { key:"timestampStr", label: "Date", sortable: false, tdClass:""},
          { key:"blNumber", label: "Nº BL",thClass:"",tdClass:"" },

          { key:"subject", label: "Objet", sortable: false, tdClass:""},
          
          { key:"customer", label: "",thClass:"",tdClass:""},
          { key:"serviceName", label: "",thClass:"",tdClass:""},
          { key:"affectedUserName", label: "",thClass:"",tdClass:""},
          { key:"user", label: "",thClass:"",tdClass:""},

          { key:"lastModifTimestampStr", label: "Dernière Modification", sortable: false, tdClass:""},
          { key:"durationTreatingClaim", label: "", sortable: false, tdClass:""},
          { key:"status", label: "Etat",  thClass:"text-left d-md-table-cell d-none", tdClass:"text-left d-md-table-cell d-none"},

          { key:"history", label: "",thClass:"text-left",tdClass:"text-left"},
          { key:"actions", label: "Ouvrir",thClass:"text-left",tdClass:"text-left"},
        ],


        claimHistoryFields: [
        
          { key:"changeTypeValue", label: "Changement", sortable: false, tdClass:""},
          { key:"oldValue", label: "Ancienne valeur",thClass:"",tdClass:"" },
          { key:"newValue", label: "Nouvelle valeur", sortable: false, tdClass:""},
          { key:"additionalNotes", label: "Notes supplémentaires",thClass:"",tdClass:""},
          { key:"creationDate", label: "Date d'ajout",thClass:"",tdClass:""},
          { key:"creationUserName", label: "Utilisateur", sortable: false, tdClass:""},
        ],

        ordersListFields: [

          { key:"submissionDate", label: "Date d'ajout", tdClass:"font-weight-bold"},
          { key:"extId", label: "Nº BC",thClass:"",tdClass:"" },
          { key:"submissionUserName", label: "Utilisateur",   thClass:" ", tdClass:" align-middle"},
         
          { key:"status", label: "Etat de livraison",thClass:"text-right" ,tdClass:"text-right align-middle"},
          { key:"claim", label:"Réclamation",thClass:"text-right d-md-table-cell d-none" , tdClass: "text-right d-md-table-cell d-none"},
        ],

        ordersList:[],

        customersList:[],
        selectedCustomer: null,

        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
        claimsList: [],
        isTableLoading: false,
        isExportingClaims: false,

        subject: null,
        message: null,

        type:"PARA",
        searchText: '', 
        blList:[],
        filteredBlList:[],
        isFilteredBlListLoading:false,
        chosenBl:{ number: null },
        showBLFormModal:false,
        editServicesList: [],
        servicesList: [],
        selectedFormService:null,
        selectedFormType:null,
        additionalNotes:null,
        showClaimModal: false,
        selectedClaim: {customer:null,},
        showClaimHistoryModal:false, 
        claimHistoryList: [],
        isTableHistoryLoading: false,
        historyTablePagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
        showTypes:false,
        selectedService:null,
        selectedType:null,
        selectedClaimNotReal:false,
        editTypesList:[],
        isInProgress:false ,
        skipWatch: false,

        filterEnd:null,
        filterStart:null,
        filterServicesList:[],
        filterCustomersList:[],
        filterSelectedState:null,
        filterSelectedCustomer:null,
        filterSelectedService:null,
        closedClaimDetails: null,

        tradersList:[],
        gotTradersList:false,
        selectedTrader:null,
        blTypeOptions: [
          { value: 0, text: "Pharmaceutiques" },
          { value: 1, text: "Para-Pharmaceutiques" }
        ],

        subjectOptions: [
          "Réclamation Commande",
          "Réclamation Livraison",
          "Réclamation Prix",
          "Réclamation Service",
          "Réclamation Financière",
          "Autre Réclamation ou suggestion"
        ],
        selectedBlType:null,
        updatedType:null,

     
    };
  },
  methods: {
    getTraders(serviceId){
        if(!this.isClaimTypeEnabled){
          return;
        }
        if(serviceId== null ){
          this.selectedTrader = null ;
           this.tradersList= [];
           return;
        }
        UsersApi.getTradersByService(serviceId).then(
            (result)=>{
              if(result.length === 0 ){
                this.gotTradersList=false;
              }else{
                this.skipWatch = true
                if(this.selectedClaim.affectedUserId !=null){
                  this.selectedTrader = { name : this.selectedClaim.affectedUserName , value : this.selectedClaim.affectedUserId};
                }
                this.tradersList=result;
                this.gotTradersList=true;
                this.$nextTick(() => {
                  this.skipWatch = false;
                });
              }
            }
        )
    },
    getALLClaimsServices(){
      ClaimApi.getServicesCount().then(
          result => {
              if(result){
                  ClaimApi.getClaimsServices(null,result,null,false).then(
                      response => {    
                      this.filterServicesList = response.list;
                  })
              }
          }
      )
    },
    closeClaimModal(){
      this.skipWatch = true;
      this.showClaimModal = false;
      this.additionalNotes=null;
      this.selectedTrader = null ; 
      this.chosenBl = { number: null };
      this.updatedType = null;
      this.selectedClaim = {customer:null,};
      this.editServicesList.forEach(service => {
        service.selected =  0;
      });
      this.servicesList.forEach(service => {
        service.selected =  0;
      });
      this.$nextTick(() => {
        this.skipWatch = false;
      });
    },
    
  
    updateService(newValue){
      this.skipWatch = true
      if(newValue==null){
        this.selectedService = null;
        this.selectedType = null;
      }else{
        this.editServicesList.forEach(service => {
          if(service.id === newValue.value ){
            service.selected = 1 ;
            this.selectedService = {name : service.name , value : service.id  };
            this.selectedType = null;
          }
        });
      }
      this.updateClaimType(this.selectedType);
      this.$nextTick(() => {
        this.skipWatch = false;
      });
    },
    changeAffectedUser(newValue){
      this.skipWatch = true

      ClaimApi.changeAffectedUser(this.selectedClaim.id,newValue==null?null :  newValue.value,this.pagemodel.currentPage, this.pagemodel.perPage).then(
        result => {
          if (result) {
          this.claimsList = result.list
          this.pagemodel.totalRows = result.total;
          this.pagemodel.currentPage = result.page;
          this.pagemodel.perPage = result.pageSize;
          this.pagemodel.pageSize = result.pageSize;
          this.skipWatch = true
          this.selectedTrader = newValue;
          if(newValue == null && this.isAdmin == false) {
            this.closeClaimModal();
            
          }
          this.$nextTick(() => {
            this.skipWatch = false;
          });
        } 
      }).catch(err => {
        console.error(err);
      });
      this.$nextTick(() => {
        this.skipWatch = false;
      });
    },
    updateClaimType(newValue) {
      this.skipWatch = true;
      if(this.selectedService == null || this.selectedService.value == null){
        this.selectedType = null;
      }else if(newValue==null) {
        this.selectedType = null;
      }else{
        this.editServicesList.forEach(service => {
          if(service.id === this.selectedService.value ){
            service.types.forEach(type => {
              if(type.id === newValue.value){
                this.selectedType = {name : type.name , value :type.id };
              }
            });        
          }
        }); 
      }
      if ( !this.selectedClaim || !this.selectedClaim.id || this.role == 0) {
        return ; 
      }

      ClaimApi.changeService(this.selectedClaim.id, this.selectedService?.value, this.selectedType?.value,this.pagemodel.currentPage, this.pagemodel.perPage).then(
        result => {
          if (result) {
          this.claimsList = result.list
          this.pagemodel.totalRows = result.total;
          this.pagemodel.currentPage = result.page;
          this.pagemodel.perPage = result.pageSize;
          this.pagemodel.pageSize = result.pageSize;
        
          this.selectedClaim.serviceId = this.selectedService?.value;
          this.selectedClaim.typeId =this.selectedType?.value;
          this.getTraders(this.selectedService?.value);
        } else {
          this.editServicesList.forEach(s => {
            s.selected = s.id === this.selectedClaim.serviceId ? 1 : 0;
            s.types.forEach(t=>{
              t.selected = s.id === this.selectedClaim.serviceId  && t.id ===  this.selectedClaim.typeId  ? 1 : 0;
            })
          });
          this.skipWatch = true;
          this.selectedType = {name : this.selectedClaim.typeName  , value : this.selectedClaim.typeId  };
          this.selectedService = {name : this.selectedClaim.serviceName  , value : this.selectedClaim.serviceId  };
          this.$nextTick(() => {
            this.skipWatch = false;
          });
        }
      }).catch(err => {
        console.error(err);
      });

      this.$nextTick(() => {
            this.skipWatch = false;
          });
    },
    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
          response => {
            this.customersList=response;
            this.filterCustomersList=response;
          }
      )
    },

    getBLs (customer) {
      
      var customerId= 
        customer==null ?
              ( this.selectedCustomer==null? 
                  ( this.selectedClaim != null ?
                  this.selectedClaim.customerId 
                  : null )
              :  this.selectedCustomer.id )   
        : customer.id ;
      this.isFilteredBlListLoading =true;
      InvoicesApi.getBLs(null, null, customerId, null, null, null, this.type)
      .then(response => {
        if (response && response.list && Array.isArray(response.list)) {
          this.blList = response.list;
          this.filterBlList(); 
          
        }
      })
      .catch(error => {
        console.error('Error fetching BLs:', error);
        this.blList = [];  
        this.filteredBlList = [];
      })
      .finally(() => {
        this.isFilteredBlListLoading = false;
      });
    },
    changeBlNumber( ){
      if (this.selectedClaim == null || this.selectedClaim.id == null || this.chosenBl == null  ) {
        return;
      }
      if(this.role ==0){
        return ;
      }
      ClaimApi.changeBlNumber(this.selectedClaim.id, this.chosenBl.number,this.pagemodel.currentPage, this.pagemodel.perPage).then(
        result => {
          if (result) {
            this.claimsList = result.list
            this.pagemodel.totalRows = result.total;
            this.pagemodel.currentPage = result.page;
            this.pagemodel.perPage = result.pageSize;
            this.pagemodel.pageSize = result.pageSize;          
              
            this.selectedClaim.chosenBl = this.chosenBl.number ;

          }         
        }
      )
    },
    changeBlType( ){
      if(!this.isClaimReportingEnabled){
        return;
      }
      if (this.selectedClaim == null || this.selectedClaim.id == null ) {
        return;
      }
      if(this.role ==0){
        return ;
      }
      ClaimApi.changeBlType(this.selectedClaim.id,this.updatedType,this.pagemodel.currentPage, this.pagemodel.perPage).then(
        result => {
          if (result) {
            this.claimsList = result.list
            this.pagemodel.totalRows = result.total;
            this.pagemodel.currentPage = result.page;
            this.pagemodel.perPage = result.pageSize;
            this.pagemodel.pageSize = result.pageSize;          
              
            this.selectedClaim.blType =  this.updatedType ;

          }         
        }
      )
    },
    filterBlList() {
      const lowerCaseSearchText = this.searchText.toLowerCase();
      this.filteredBlList = this.blList.filter(item => 
        item.number ? item.number.toLowerCase().includes(lowerCaseSearchText) : '' || 
        item.date ?  item.date.toLowerCase().includes(lowerCaseSearchText) : '' || 
        item.totalWithTaxes ?  item.totalWithTaxes.toLowerCase().includes(lowerCaseSearchText) :'' 
      );
    },
    selectItem(item) {
    
      this.chosenBl = { ...item }
    },
   
    getClaimsServices(){
      ClaimApi.getClaimsServices(null,null,null,false).then(
        response => {    
          this.servicesList = response.list;
          this.editServicesList= response.list ;
        
      })
    },

    getClaimHistory(item){
      if (item == null) return;

      if(this.role!==0){
        this.selectedClaim = { ...item };

        this.getClaimAllHistory();
      }
    },
    getClaimAllHistory(){
      if(!this.isClaimTypeEnabled){
        return;
      }
      if(this.role!==0){

        this.isTableHistoryLoading = true;
       
        ClaimApi.getClaimHistory( this.selectedClaim .id,this.historyTablePagemodel.currentPage, this.historyTablePagemodel.perPage).then(result=>{
          if(result){
            this.claimHistoryList = result.list
              this.historyTablePagemodel.totalRows = result.total;
              this.historyTablePagemodel.currentPage = result.page;
              this.historyTablePagemodel.perPage = result.pageSize;
              this.historyTablePagemodel.pageSize = result.pageSize;
            this.showClaimHistoryModal = true ; 
          }
         
        }) .finally(() => {
            this.isTableHistoryLoading = false;
        });
      }
    },
   
   

      addClaim() {
   
      
        var customerId = this.selectedCustomer ? this.selectedCustomer.id : null; 
        
        ClaimApi.addClaim(this.subject, this.message , this.chosenBl == null ? null : this.chosenBl.number,this.selectedBlType == null ? null : this.selectedBlType.value,customerId, this.selectedFormService?.id, this.selectedFormType?.id,this.pagemodel.currentPage, this.pagemodel.perPage).then(
          ()=>{
            if( this.canAccessClaimList){
              this.getClaims();
            }

            this.chosenBl= { number: null };
            this.selectedBlType = null;
            this.subject = null;
            this.message = null;
            this.selectedCustomer=null;
            this.selectedFormService=null;
            this.selectedFormType=null;
            this.servicesList.forEach(service => {
              service.selected=0;
              service.types.forEach(type=>{
                type.selected=0;
              })
            });
            this.showTypes=false;
          }
        ) .catch(() => {
        });
      },

      changeStatus(status) {

        if (this.selectedClaim == null || this.selectedClaim.id == null) {
          return;
        }

        ClaimApi.changeStatus(this.selectedClaim.id, status,this.additionalNotes,this.pagemodel.currentPage, this.pagemodel.perPage).then(
          (result)=>{
            if (result) {
              this.claimsList = result.list
              this.pagemodel.totalRows = result.total;
              this.pagemodel.currentPage = result.page;
              this.pagemodel.perPage = result.pageSize;
              this.pagemodel.pageSize = result.pageSize;

              this.additionalNotes=null;
              this.showClaimModal = false;
              this.editServicesList.forEach(service => {
                service.selected = 0;
              });
              this.showTypes=false
            }
          }
        )
      },
      changeClaimValid(newValue){
        if(this.role === 0){
          return;
        }
        if(!this.isClaimTypeEnabled){
          return;
        }
        
        if (this.selectedClaim == null || this.selectedClaim.id == null) {
          return;
        }

        ClaimApi.changeClaimValid(this.selectedClaim.id, newValue,this.pagemodel.currentPage, this.pagemodel.perPage).then(
          (result)=>{
            if (result) {
              this.claimsList = result.list
              this.pagemodel.totalRows = result.total;
              this.pagemodel.currentPage = result.page;
              this.pagemodel.perPage = result.pageSize;
              this.pagemodel.pageSize = result.pageSize;

              
              this.selectedClaimNotReal= newValue;
            }
          }
        )
      },

      getClaims() {
        this.isTableLoading = true;
        this.isTableBusy = true;
        if(!this.isClaimTypeEnabled){
            this.filterSelectedService = null ;
        }
        ClaimApi.getClaims(this.pagemodel.currentPage, this.pagemodel.perPage, this.filterStart, this.filterEnd, 
                    this.filterSelectedCustomer == null ? null : this.filterSelectedCustomer.id ,
                    this.filterSelectedService == null ? null : this.filterSelectedService.value ,
                    this.filterSelectedState == null ? null : this.filterSelectedState.value,
                    this.agencySelected ? this.agencySelected.id : null)
            .then(
            result => {
              this.claimsList = result.list
              this.pagemodel.totalRows = result.total;
              this.pagemodel.currentPage = result.page;
              this.pagemodel.perPage = result.pageSize;
              this.pagemodel.pageSize = result.pageSize;
          })
          .finally(() => {
            this.isTableLoading = false;
        })
      },

      exportClaims() {
        this.isExportingClaims = true;
        if(!this.isClaimTypeEnabled){
          this.filterSelectedService = null;
        }
        ClaimApi.exportClaims(this.pagemodel.currentPage, this.pagemodel.perPage, this.filterStart, this.filterEnd,
                    this.filterSelectedCustomer == null ? null : this.filterSelectedCustomer.id,
                    this.filterSelectedService == null ? null : this.filterSelectedService.value,
                    this.filterSelectedState == null ? null : this.filterSelectedState.value,
                    this.agencySelected ? this.agencySelected.id : null)
          .finally(() => {
            this.isExportingClaims = false;
          });
      },

      showClaim(item) {
        if (item == null) {
          return;
        }
        this.selectedClaim = { ...item };
        this.chosenBl = { number: null };
        if(item.blNumber!=null && item.blNumber != ''){
          this.chosenBl = { number:  item.blNumber};
        }
        this.updatedType = this.selectedClaim.blType
        this.editServicesList.forEach(service => {
          service.selected = this.selectedClaim.serviceId != null && service.id === this.selectedClaim.serviceId ? 1 : 0;
        });
        this.showClaimModal=true;

        if(item.status == 2 && item.id){
          this.getClosedDetails(item.id)
        }

        if(item?.isValidClaim !=null){
          this.selectedClaimNotReal = item.isValidClaim
        }else{
          this.selectedClaimNotReal = false
        }

        if(item?.typeId != null ) {
          this.selectedType = {name : item.typeName  , value : item.typeId  };
        }else{
          this.selectedType = null;
        }

        if(item?.serviceId != null ) {
        this.selectedService = {name : item.serviceName  , value : item.serviceId  };
        }else {
            this.selectedService =null;
        }
        
        if(this.role != 0){
          if(item?.serviceId != null ) {
            this.getTraders(item.serviceId);
          }else{
            this.tradersList = []
          }
          this.selectedTrader = this.tradersListOptions.filter(tlo => {tlo.value == item.affectedUserId });
        }


      },
      
      cancelClaimBlModal(){
        this.showBLFormModal = false;
        this.chosenBl = { number : null };
        this.searchText = '';
      },
      saveClaimBlModal(){
        this.searchText = '';
        this.showBLFormModal = false;
        
      },
      showBLModal() {
        this.getBLs();
        this.searchText = '';
        this.showBLFormModal=true;
      },
      saveData(){ 
        this.changeBlNumber();
      },

      getClosedDetails(claimId){
        ClaimApi.getClosedDetails(claimId).then((result) => {
          this.closedClaimDetails = result
        })
      }


  },
    

  watch : {
    type() {
      this.getBLs();
    },
    selectedCustomer(newCustomer) {
      if(newCustomer ==null){
          this.chosenBl = { number : null };
      }
    },
    filterSelectedCustomer: function(){ 
        this.getClaims() 
    },
    filterSelectedService: function(){ 
        this.getClaims()  
    },
    filterSelectedState: function(){ 
        this.getClaims() 
    },
    filterEnd: function(){
        this.getClaims()
    },
    filterStart: function(){
        this.getClaims()
    },

    agencySelected: function() {
      this.getClaims();
    },

    selectedFormService(newValue){
      this.selectedFormService= newValue
      if (this.selectedFormService && this.selectedFormService.types && this.selectedFormService.types.length > 0) {
        this.showTypes=true;
      } else {
        this.selectedFormType = null;
        this.showTypes=false;
      }
    }
  }

  
};
</script>


<style scoped>
.services-container {
  max-height: 160px; 
  overflow-y: auto; 
  padding-right: 10px; 
}
.selected-row {
  background-color: #00ACC8; 
  color: white; 
  font-weight: bold;
  border-radius: 5px;
}

</style>

<template>
  <Layout>
    <div v-if="role == 0 || ( permission && permission.some(pr=> pr.includes('SUPPLIER_ADD_CLAIM') || pr.includes('SUPPLIER_ADMIN') ))" class="row p-sm-4  ">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div class="row">

              <div class="col-md-8 col-sm-12">
                <h3 class="card-title text-primary" style="font-size:1.5em;">Nouvelle Réclamation ou Suggestion</h3>
              </div>


            </div>
          <div class="row ">    
            <div class="col-lg-2  col-xs-0"/>

              <div  class=" col-lg-6 pt-4 mr-4" :class="[isClaimReportingEnabled? 'col-12 col-md-8' :  'col-11 col-md-8' ]">
            
                <div class="col-12  position-relative" :class="[isClaimReportingEnabled? 'col-sm-11 col-md-12' :  ' ' ]">
                  <b-form-group  label-for=""  class="mt-2 mb-0">
                    <label >
                      <span style="color : black">Objet</span><span class="text-danger"> *</span>
                    </label>

                      <v-select v-if="isPredifindSubjectClaimEnabled"
                        class="style-vselect font-size-14"
                        :options="subjectOptions"
                        v-model="subject"
                        placeholder="Sélectionner un objet"
                      >
                      </v-select>

                      <b-form-input v-else v-model="subject" :maxlength="50" class="form-control font-size-14 mr-4" placeholder="Objet"/>

                  </b-form-group> 


                  <b-form-group v-if="role!==0"  label-for="" class="mt-4 mb-0 ">
                    <label>
                      <span style="color : black">Client</span><span class="text-danger"> *</span>
                    </label>
                    <div class="col-12" >
                      <div class=" text-right">
                          <b-form-group label-for="" class="mb-0">
                            <v-select class="style-vselect-selectedcustomer" style="font-size:1.2em;" :options="customersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName"  v-model="selectedCustomer">
                              <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                            </v-select>
                          </b-form-group>
                      </div>
                    </div>
                  </b-form-group>

                  
                  <div v-if="isClaimReportingEnabled" class="row">
                    <b-form-group  label-for="" class="col-10 col-sm-11 col-lg-5 mt-4 mb-0">
                        <label>
                          <span style="color : black">Bon de Livraison N°</span>
                        </label>
                        <b-input-group >
                        <b-form-input :disabled="role!==0 && selectedCustomer==null"  :value="chosenBl.number" v-model="chosenBl.number" class="form-control font-size-12" placeholder="Optionnel"/>

                        </b-input-group>
                    </b-form-group>

                    <b-form-group class="col-2 col-sm-1 pl-2 mt-4 pt-4 mb-0" >
                          <b-button 
                            variant="light" 
                            class="position-absolute bl-search-icon w-100 p-1" 
                            @click="showBLModal"
                            :disabled="role!==0 && selectedCustomer==null"
                          > 
                            <div  v-if="role !== 0 && selectedCustomer == null" 
                              v-b-tooltip.hover.bottom="'Veuillez sélectionner un client pour activer ce bouton.'" 
                              class="d-inline-block w-100"
                              style="position: relative;">
                              <i class="mdi mdi-file-search-outline font-size-18 font-weight-bold text-primary align-middle p-0 m-0 "></i>
                            </div>
                            <i v-else class="mdi mdi-file-search-outline font-size-18 font-weight-bold text-primary align-middle p-0 m-0 "></i>

                          </b-button>
                    </b-form-group>

                    <b-form-group class="col-lg-6 mt-4 mb-0 pl-lg-2" >
                      <label>
                        <span style="color : black">Type du bon de livraison</span>
                      </label>
                      <b-form-group   label-for="" class="col-12">
                        <v-select class="style-vselect-big " style="font-size:1.2em;" :options="blTypeOptions" label="text" v-model="selectedBlType">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                      </b-form-group>
                    </b-form-group>
                  </div>
                  <b-form-group v-else label-for="" class="mt-4 mb-0">
                      <label>
                        <span style="color : black">Bon de Livraison N°</span>
                      </label>
                      <b-input-group >
                      <b-form-input :disabled="role!==0 && selectedCustomer==null"  :value="chosenBl.number" v-model="chosenBl.number" class="form-control" placeholder="Optionnel"/>
                        <b-button 
                          variant="light" 
                          class="position-absolute top-50 translate-middle-y p-1" 
                          style="right: -45px; width: 38px !important; height: 36px !important;" 
                          @click="showBLModal"
                          :disabled="role!==0 && selectedCustomer==null"
                        > 
                          <div  v-if="role !== 0 && selectedCustomer == null" 
                            v-b-tooltip.hover.bottom="'Veuillez sélectionner un client pour activer ce bouton.'" 
                            class="d-inline-block w-100"
                            style="position: relative;">
                            <i class="mdi mdi-file-search-outline font-size-18 font-weight-bold text-primary align-middle p-0 m-0 "></i>
                          </div>
                          <i v-else class="mdi mdi-file-search-outline font-size-18 font-weight-bold text-primary align-middle p-0 m-0 "></i>

                        </b-button>
                      </b-input-group>
                  </b-form-group>
                  <!-- Service  -->
                  <b-form-group  v-if="isClaimTypeEnabled"  label-for=""  class="mt-2 mt-lg-2  mb-0">
                    <label class=" text-dark ">
                      <span style="color : black">Nature de l'erreur</span>
                    </label>
                    <v-select style="font-size:1.2em;" 
                      :options="servicesList"
                      label="name"
                      placeholder="Nature de l'erreur"  v-model="selectedFormService" :searchable="false">
                      <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                    </v-select>
                  </b-form-group>


                    <!-- Service Type  -->
                  <b-form-group v-if="isClaimTypeEnabled && selectedFormService && selectedFormService.types && showTypes== true"  label-for=""
                         class="col-12 mt-4 mb-0">
                    <label class=" text-dark">
                      <span style="color : black">Type de réclamation</span>
                    </label>
                      <v-select style="font-size:1.2em;" 
                      :options="selectedFormService.types"
                      :placeholder="$t('lists.type.label')" label="name" v-model="selectedFormType" :searchable="false">
                      <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                    </v-select>
                  </b-form-group>
              
                </div>
              </div>
            </div>
                
            <div class="row"> 
              <div class="col-lg-2 col-xs-0"/>
              <div class="col-lg-8 col-md-10 col-xs-12">
                <b-form-group label-for=""  class="mt-4 mb-0">
                  <label>
                      <span style="color : black">Message</span><span class="text-danger"> *</span>
                    </label>
                  <textarea
                      v-model="message"
                      class="form-control font-size-14"
                      :maxlength="3000"
                      rows="10"
                      placeholder="Ajouter votre réclamation ou suggestion"
                  />
                </b-form-group>
              </div>
            </div> 
           
            <div class="row pt-3"> 
              <div class="col-md-7 col-sm-9 col-xs-0"/>
                <div class="col-sm-3 col-xs-12 ">
                  <b-button variant="primary" class="w-100 font-weight-bold "  @click="addClaim()">
                      <i class="fas fa-paper-plane align-middle mr-2 ml-2" /> Envoyer
                  </b-button>
              </div>
            </div> 

          </div>
        </div>
      </div>
    </div>  
    
  <div v-if="canAccessClaimList" class="row pt-4 p-sm-4">
    <div class="col-lg-12">
      <div class="card border border-primary">
        <div class="card-body" >
          <div class="row">
            <div class="col-md-8 col-sm-12">
                <h3 class="card-title text-primary" style="font-size:1.5em;">Liste des Réclamations & Suggestions</h3>
            </div>
            <div v-if="role == 1 && isExportClaimsCsvEnabled" class="col-md-4 col-sm-12 text-md-right">
              <b-button variant="success" :disabled="isExportingClaims || isTableLoading" @click="exportClaims()">
                <b-spinner v-if="isExportingClaims" small class="mr-2" />
                <i v-else class="fas fa-file-csv mr-2" />Exporter CSV
              </b-button>
            </div>
          </div>
          <div class="row mt-4">
            <b-form-group v-if="canAccessCustomerList" class="col-12 col-sm-6 col-md-4 pr-sm-2 "  label-for="" >
                <label>
                    <span style="color : black">Client</span>
                </label>
                <div class="col-12" >
                    <div class=" text-right">
                        <b-form-group label-for="">
                        <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName"  v-model="filterSelectedCustomer">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                        </b-form-group>
                    </div>
                </div>
            </b-form-group>
            <div v-if="canAccessCustomerList && isClaimTypeEnabled" class="col-xs-0 col-sm-6 d-none d-sm-block d-md-none"></div>
            <b-form-group  label-for="" class="col-12 col-sm-6 col-md-4 pr-sm-2 ">
                <label>
                    <span style="color : black">{{$t('lists.status.filter')}}</span>
                </label>
                <v-select class="style-vselect-big" style="font-size:1.2em;" :options="[{name :$t('reporting.supplier.tabClaimsState.claimStatus.statusLabel.new'),value: 0},{name :$t('reporting.supplier.tabClaimsState.claimStatus.statusLabel.inProgress'), value: 1},{name :$t('reporting.supplier.tabClaimsState.claimStatus.statusLabel.closed'), value: 2}]" 
                :placeholder="$t('lists.status.label')" label="name" v-model="filterSelectedState" :searchable="false">
                <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                </v-select>
            </b-form-group>


            <div v-if="isAdmin" class="col-12 col-sm-6 col-md-4 pr-sm-2 ">

              <b-form-group v-if="this.filterByAgency  && !isAgencySupplier"
              :class="filterByAgency ? 'ml-md-3 ml-0' : 'mr-0'"
              :label="$t('lists.agency.filter')"
              label-for="agency-filter"
              >
              <v-select
                  id="agency-filter"
                  class="style-vselect-big"
                  style="font-size:1.2em;"
                  :options="agencyList"
                  :placeholder="$t('lists.agency.label')"
                  label="name"
                  v-model="agencySelected"
              >
                  <span slot="no-options">
                  {{$t('lists.emptyLists.label')}}
                  </span>
              </v-select>
              </b-form-group>

            </div>


            <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-sm-6 col-md-4">
              <label>
                  <span style="color : black">{{ $t('lists.service.filter') }}</span>
              </label>
              <v-select class="style-vselect-big" style="font-size:1.2em;" 
                :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedService" :searchable="false">
                <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                </v-select>
            </b-form-group>
        </div>
        <div  class="row mt-2">
          <div class="col-12 col-sm-6 col-md-4 pr-sm-2 ">
            <b-form-group   label-for="">
                <label>
                    <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}}</span>
                </label>
                <b-form-datepicker
                v-model="filterStart"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div class="col-12 col-sm-6 col-md-4 ">
            <b-form-group   label-for="">
                <label>
                    <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}}</span>
                </label>
                <b-form-datepicker
                v-model="filterEnd"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
          </div>
        </div> 
        <div class="row pt-4" style="min-height:450px;"> 
               
          <div class="col-sm-12 col-xs-12">

            <div class="table-responsive">
            <b-table 
              :busy="isTableLoading"
              :striped="true"

              :small="false"
              :hover="true"

              :items="claimsList"
              :fields="claimsListFields"

              :perPage="pagemodel.perPage"
              class="table  ">

                  <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                  </template>
                  <template v-slot:head(serviceName)>
                        <span v-if="isClaimTypeEnabled" >Nature de l'erreur</span>
                  </template>
                  <template v-slot:cell(serviceName)="{item}">
                        <span v-if="isClaimTypeEnabled">{{  item.serviceName ? item.serviceName : '-' }}</span>
                        <div style="font-size: 10px;" v-if="isClaimTypeEnabled">
                          {{  item.officerUserName ? item.officerUserName + ( item.treatmentTimestamp ? (' à ' + item.treatmentTimestamp) : '' )  : '' }}
                        </div>
                  </template>
                  <template v-slot:head(durationTreatingClaim)>
                        <span v-if="isClaimTypeEnabled && role!==0" >Durée de traitement</span>
                  </template>
                  <template v-slot:cell(durationTreatingClaim)="{value}">
                        <span v-if="isClaimTypeEnabled && role!==0">{{ value }}</span>
                  </template>
                  <template v-slot:cell(status)="{value}">
                    <h5><b-badge href="#" :variant="value == 0 ? 'danger' : value == 1 ? 'warning' : value == 2 ?'secondary' : 'light'">{{value == 0 ? 'Nouvelle' : value == 1 ? 'En cours' : value == 2 ? 'Cloturée' : 'Rouverte'}}</b-badge></h5>
                  </template>

                  <template v-slot:cell(actions)="{item}">
                    <i class="mdi mdi-comment-text-multiple-outline font-size-18 font-weight-bold text-primary align-middle" @click="showClaim(item)" style="cursor: pointer;" />
                  </template>
                  
                  <template v-slot:cell(history)="{item}">
                    <i v-if="isClaimTypeEnabled && role!==0"  class="mdi mdi-history font-size-18 font-weight-bold text-warning align-middle ml-2" @click="getClaimHistory(item)"  style="cursor: pointer;"/>
                  </template>
                  <template v-slot:head(history)>
                    <span v-if="isClaimTypeEnabled && role!==0" >Historique</span>
                  </template>
                  
                  <template v-slot:cell(blNumber)="{value}">
                    <span class="font-weight-bold">{{ value ? value  : "-" }}</span>
                  </template>

                  <template v-slot:cell(timestampStr)="{value, item}">
                    <span :class="item.status != 2 ? 'font-weight-bold' : ''">{{ value }}</span>
                  </template>

                  <template v-slot:cell(lastModifTimestampStr)="{value, item}">
                    <span :class="item.status != 2 ? 'font-weight-bold' : ''">{{ value ? value : '-' }}</span>
                  </template>

                  <template v-slot:cell(subject)="{value, item}">
                    <span :class="item.status != 2 ? 'font-weight-bold' : ''">{{ value }}</span>
                  </template>

                  <template v-slot:head(customer)>
                    <span v-if="role!==0">Client</span>
                  </template>
                  <template v-slot:cell(customer)="{value,item}">
                    <span v-if="role!==0" :class="item.status != 2 ? 'font-weight-bold' : ''">{{ value }}</span>
                  </template>

                  <template v-slot:cell(user)="{value, item}">
                    <span v-if="role!==0"  :class="item.status != 2 ? 'font-weight-bold' : ''">{{ value ? value : '-' }}</span>
                  </template>
                  <template v-slot:head(user)>
                    <span v-if="role!==0" >Créé par</span>
                  </template>

                  
                  <template v-slot:head(affectedUserName)>
                        <span v-if="isClaimTypeEnabled && role != 0 " >Affectation</span>
                  </template>
                  <template v-slot:cell(affectedUserName)="{value}">
                        <span v-if="isClaimTypeEnabled && role != 0">{{ value }}</span>
                  </template>
              </b-table>
            </div>
              <span v-if="!isTableLoading && !claimsList.length" 
              class="d-flex justify-content-center m-4 text-danger" >Aucune réclamation ou suggestion</span>
          </div>
      </div> 

      <!-- Pagination -->
         <div class="row pt-3 ">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getClaims()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodel.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :disabled="isTableLoading" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getClaims()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>  
      <!-- Fin Pagination  -->


    </div>
  </div>
    </div>
  </div>  
    <b-modal
      v-model="showClaimHistoryModal"
      :title="'Réclamation ' + this.selectedClaim.customer + ' du ' + this.selectedClaim.timestampStr"
      centered
      hide-footer
      title-class="text-primary"
      title-tag="h5"
      header-close-variant="danger"
      size="xl"
    >
      <div class="row pt-4" style="min-height:450px;">
        <div class="col-sm-12 col-xs-12 pr-3">
          <div class="table-responsive">
          <b-table 
            :busy="isTableHistoryLoading"
            :striped="true"

            :small="false"
            :hover="true"

            :items="claimHistoryList"
            :fields="claimHistoryFields"
            class="table  ">
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                      <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                  </div>
                </template> 
            </b-table>
          </div>  
            <span v-if="!isTableHistoryLoading && !claimHistoryList.length" 
            class="d-flex justify-content-center m-4 text-danger" >Aucun Historique pour cette réclamation</span>
        </div>
      </div> 
  
       <!-- Pagination -->
       <div class="row pt-3 ">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getClaimAllHistory()"  v-model="historyTablePagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{historyTablePagemodel.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="historyTablePagemodel.currentPage" :disabled="isTableHistoryLoading" :per-page="historyTablePagemodel.pageSize" :total-rows="historyTablePagemodel.totalRows" @input="getClaimAllHistory()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>  
        <!-- Fin Pagination  -->
    </b-modal>


    <b-modal
      v-model="showBLFormModal"
      :title="chosenBl == null || chosenBl.number == null ? 'Bon de livraison' :  'Bon de livraison N: '  + chosenBl.number"
      centered
      hide-footer
      title-class="text-primary"
      title-tag="h5"
      hide-header-close      
      size="lg"
      no-close-on-backdrop
    >
      <div class="mt-2 mb-2">
        <div v-if="!isParaOnly" class="row  mb-3">
          <div class="col-12">
            <b-form-radio
                class="custom-radio custom-radio custom-radio-primary mb-3"
                value="PARA"
                v-model="type"><span :class="type === 'PARA' ? 'text-primary font-weight-bold' : ''">{{ $t('ordersMenu.para') }}</span>
              </b-form-radio> 

              <b-form-radio
                class="custom-radio custom-radio custom-radio-primary mb-3"
                value="PHARMA"
                v-model="type"><span :class="type === 'PARMA' ? 'text-primary font-weight-bold' : ''">
                  {{ $t('ordersMenu.pharma') }}</span>
              </b-form-radio> 
          </div>
        </div>

        <div class="col-12">
          <b-form-group label-for="" >
            <label>
              <span style="color : black">Liste des Bons de livraison</span>
            </label>
                  <b-form-input v-model="searchText" placeholder="Filter par référence" class="form-control"  @input="filterBlList"/>
            </b-form-group>
        </div>

        <div v-if="isFilteredBlListLoading"><b-spinner small type="border" class="mr-2"></b-spinner>Chargement de la liste</div>
        <div v-else style="position: relative;
                    display: inline-block;
                    width: 100%;">
          <div class="row " style="padding: 0.35rem 1.5rem;">
              <div class="col-4">Référence</div>
              <div class="col-4">Date</div>
              <div class="col-4 text-right">Total TTC (TND)</div>
          </div>
          <ul style=" height: 200px; 
                  width:100%; 
                  overflow-y: auto; 
                  padding: 0;
                  position: relative;
                  z-index: 1000;">

            
            <li 
              v-for="item in filteredBlList"
              :key="item.number"
              @click="selectItem(item)"
              class="dropdown-item "
              :class="{'selected-row': chosenBl && chosenBl.number === item.number}"
            >
              <div class="row">
                <div class="col-4">{{ item.number }}</div>
                <div class="col-4">{{ item.date }}</div>
                <div class="col-4 text-right">{{ item.totalWithTaxes }}</div>
              </div>
            </li>
            <div  v-if="!filteredBlList || filteredBlList.length == 0" class="mt-5" > {{$t('lists.emptyLists.label')}}</div>
          </ul>
        </div>
        <div class="row pt-2"> 
            <div  class="col-sm-4 col-xs-12 p-2">
              <b-button variant="secondary" class="w-100 font-weight-bold " @click="cancelClaimBlModal">
                {{$t('buttons.cancel')}}
                  </b-button>
            </div>
            <div  class="col-sm-4 col-xs-0"/>
            <div class="col-sm-4 col-xs-12 p-2">
                <b-button variant="primary" class="w-100 font-weight-bold "  @click="saveClaimBlModal">
                  {{$t('buttons.continue')}}
                </b-button>
            </div>
        </div>
      </div>
    </b-modal>

  

    <b-modal v-model="showClaimModal" 
        hide-header 
        hide-footer 
        centered 
        title-class="text-primary"
        title-tag="h5"
        header-close-variant="danger"
        size="lg"
        @hide="closeClaimModal"
        :no-close-on-backdrop="true">

          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3 class="card-title text-primary" style="font-size:1.5em;">{{'Réclamation ' + this.selectedClaim.customer + ' du ' + this.selectedClaim.timestampStr}}</h3>
            <span @click="closeClaimModal" style="cursor:pointer; font-size:1.5rem; line-height:1; color:#6c757d;"
              class="ml-auto" aria-label="Close" > &times; 
            </span>
          </div>
            <div class="row pt-2"> 
                
                <div class="col-12">
                  <b-form-group label-for="" >
                    <label>
                      <span style="color : black">Objet</span>
                    </label>
                          <b-form-input v-model="selectedClaim.subject" :maxlength="50" disabled class="form-control font-size-16"/>
                    </b-form-group>
                </div>
            </div>

           

            <div class="row pt-2"> 
                
                <div v-if="isClaimTypeEnabled" class="col-12">
                  <div  class="col-12 col-lg-6">
                    <label>
                      <span style="color : black">Nature de l'erreur</span>
                    </label>
                    <b-form-group   label-for="" class="pr-lg-2 ">
                      <v-select class="style-vselect-big" style="font-size:1.2em;" 
                      :disabled="role==0"
                      :options="editServicesList.map(service => ({ name: service.name, value: service.id }))"
                      placeholder="Nature de l'erreur" label="name"
                      v-model="selectedService"
                      @input="updateService(selectedService)"
                      :searchable="false">
                      <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                      </v-select>
                    </b-form-group>
                </div>
                <div  class="col-12 col-lg-6" v-if="role!=0">
                    <label>
                      <span style="color : black">Affectation</span>
                    </label>
                    <b-form-group v-if="gotTradersList"  label-for="" class=" pr-lg-2 ">
                      <v-select class="style-vselect-big" style="font-size:1.2em;" 
                      :options="tradersListOptions"
                      :placeholder="$t('lists.trader.label')" label="name" v-model="selectedTrader"
                      @input="changeAffectedUser(selectedTrader)"
                      :searchable="false">
                      <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                      </v-select>
                    </b-form-group>
                    <div class="mb-3" v-else>Aucun utilisateur affecté à cette nature d'erreur</div>
                </div>
                <div  class="col-12 col-lg-6">
                  <label>
                      <span style="color : black">Type de réclamation</span>
                    </label>
                  <b-form-group   label-for="" class="col-12  pr-lg-2 ">
                    <v-select class="style-vselect-big" style="font-size:1.2em;" 
                    :options="this.selectedServiceOptions"
                    :disabled="role==0"
                    :placeholder="$t('lists.type.label')" label="name"
                     v-model="selectedType"
                     @input="updateClaimType(selectedType)"

                     :searchable="false">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                    </v-select>
                  </b-form-group>
                  
                </div>
              </div>

            </div>
            <div class="row">
              <b-form-group  label-for="" class=" pr-2 mb-0" :class="[isClaimReportingEnabled? 'col-9 col-lg-5  mt-3' :  ' col-10 ' ]">
                  <label>
                    <span style="color : black">Bon de Livraison N°</span>
                  </label>
                  <b-input-group >
                      <b-form-input :disabled="role==0"  :value="chosenBl.number" v-model="chosenBl.number" class="form-control font-size-12" placeholder="Optionnel"/>
                  </b-input-group>                  
              </b-form-group>
              <b-form-group class=" pt-4 mb-0" :class="[isClaimReportingEnabled? 'col-3 col-lg-2 mt-3' : 'col-2' ]">
                <div class="d-flex justify-content-start align-items-center gap-2 flex-nowrap">
                  <b-button v-if="isClaimTypeEnabled &&  role!==0"
                      variant="light" 
                      class="bl-search-icon  p-1" 
                      @click="showBLModal"
                      :disabled="role==0"
                    > 
                    <i class="mdi mdi-file-search-outline font-size-18 font-weight-bold text-primary align-middle p-0 m-0 "></i>
                  </b-button>
            
                  <b-button v-if="role!==0"
                    variant="success" 
                    :class="[isClaimReportingEnabled? 'ml-2 h-50  ' :  'mt-1' ]"
                    @click="saveData"
                    :disabled="role==0"
                    > 
                    <i class="fas fa-save"></i>
                  </b-button>
                </div>
              </b-form-group>
            
              <b-form-group v-if="isClaimReportingEnabled" class="col-lg-5 mt-3 mb-0 pl-lg-2" >
                <label>
                  <span style="color : black">Type du bon de livraison</span>
                </label>
                <b-form-group   label-for="" class="col-12  pr-lg-2 ">
                  <v-select class="style-vselect-big " style="font-size:1.2em;" :options="blTypeOptions" label="text" v-model="updatedType"  :reduce="option => option.value"  @input="changeBlType()">
                      <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                  </v-select>
                </b-form-group>
              </b-form-group>
            </div>

            <div v-if=" isClaimTypeEnabled && role !== 0" class="row pt-2">
              <div class="col-12">
                <b-form-group>
                  <b-form-checkbox
                    v-model="selectedClaimNotReal"
                     @input="changeClaimValid(selectedClaimNotReal)"
                    :disabled="role === 0"
                    name="notRealClaim"
                    switch
                  >
                    <span style="color: black; font-size: 1.1em;">Fausse réclamation</span>
                  </b-form-checkbox>
                </b-form-group>
              </div>
            </div>

            <div class="row" :class="[isClaimReportingEnabled? 'mt-2' :  ' mt-4 ' ]"> 

                <div class="col-12">
                    <b-form-group  label-for="">
                      <label>
                      <span style="color : black">Message</span>
                    </label>
                      <textarea
                          v-model="selectedClaim.message"
                          class="form-control"
                          :maxlength="3000"
                          rows="5" disabled
                          placeholder="Ajouter votre réclamation ou suggestion"
                      />
                    </b-form-group>
                </div>

            </div>
           
            <div  class="row pt-2">
              <div v-if="this.selectedClaim.status != 2" class="col-12">
                  <label>
                    <span style="color : black">Actions réalisées pour clôturer la réclamation :</span><span class="text-danger"></span>
                  </label>
                  <textarea 
                    v-model="additionalNotes" 
                    class="form-control"
                    :maxlength="3000"
                    rows="5"
                    placeholder="Indiquez les actions effectuées..."
                  ></textarea>
                
              </div>
              <div v-else-if="closedClaimDetails">
                <div v-if="closedClaimDetails.creationUserName">
                 <span class="font-weight-bold text-dark">Reclamation Clôturée par: </span>{{ closedClaimDetails.creationUserName }}
                </div>
                <div v-else>
                  
                </div>

                <div v-if="closedClaimDetails.additionalNotes">
                  <span class="font-weight-bold text-dark">Actions réalisées: </span> {{ closedClaimDetails.additionalNotes }}
                </div>
              </div>
            </div>

            <div v-if="role!==0" class="row pt-2"> 

              

              <div v-if="selectedClaim.status == 0" class="col-sm-4 col-xs-12 p-2">
                <b-button variant="warning" class="w-100 font-weight-bold "  @click="changeStatus(1)">
                        <i class="fas fa-history align-middle font-size-16 mr-2 ml-2" /> En cours
                    </b-button>
              </div>

              <div v-if="isClaimTypeEnabled && selectedClaim.status == 2" class="col-sm-4 col-xs-12 p-2">
                  <b-button variant="warning" class="w-100 font-weight-bold "  @click="changeStatus(1)">
                          <i class="fas fa-sync align-middle font-size-16 mr-2 ml-2" /> Réouvrir
                      </b-button>
              </div>

              <div v-if="selectedClaim.status !== 2 && role === 1" class="col-sm-4 col-xs-12 p-2">
                  <b-button variant="secondary" class="w-100 font-weight-bold "   @click="changeStatus(2)">
                      <i class="fas fa-check-circle align-middle font-size-16 mr-2 ml-2" /> Cloturer
                  </b-button>
              </div>
              <div  v-if="selectedClaim.status !== 0" class="col-sm-4 col-xs-0"/>

              <div class="col-sm-4 col-xs-12 p-2">
              </div>

            </div>

            <div v-if="role == 0" class="row pt-2"> 

                

                <div v-if="isClaimTypeEnabled && selectedClaim.status == 2" class="col-sm-4 col-xs-12 p-2">
                  <b-button variant="warning" class="w-100 font-weight-bold "  @click="changeStatus(1)">
                          <i class="fas fa-sync align-middle font-size-16 mr-2 ml-2" /> Réouvrir
                      </b-button>
                </div>

                <div  v-if="selectedClaim.status !== 2 && role === 1" class="col-sm-4 col-xs-12 p-2">
                    <b-button variant="secondary" class="w-100 font-weight-bold "  @click="changeStatus(2)">
                        <i class="fas fa-times-circle align-middle font-size-16 mr-2 ml-2" /> Cloturer
                    </b-button>
                </div>
                <div class="col-sm-4 col-xs-0"/>

              <div class="col-sm-4 col-xs-12 p-2">
              </div>
            </div>

            
      </b-modal>

  </Layout>
</template>

<style scoped >
@media (max-width: 768px) {
  .bl-search-icon {
    max-width: 38px !important; 
    min-width: 45px !important; 
    max-height: 45px !important;
  }
}
@media (min-width: 768px)and (max-width: 992px) {
  .bl-search-icon {
    max-width: 38px !important; 
    min-width: 45px !important; 
    max-height: 50px !important;
    min-height: 40px !important;
  }
}
@media (min-width: 992px) {
  .bl-search-icon {
    width: 100%;
    max-width: 38px !important; 
    max-height: 48px !important;
  }
}
</style>